module.exports = __webpack_public_path__ + "static/media/barcode_icon.49463e61.jpg";